module.exports = __webpack_public_path__ + "static/media/software_lp_hero.c2996c1c.png";